<template>
  <div class="focus-layout page-wrap">
    <hidden point="mdUp">
      <div class="logo logo-header">
        <router-link :to="{ name: 'welcome' }">
          <img :src="ASSETS_URL + 'logo.svg'" alt="B" />
          <p class="use-text-subtitle2">
            {{ brand.projectName }}
          </p>
        </router-link>
      </div>
    </hidden>
    <v-container class="max-lg inner-wrap">
      <div class="decoration">
        <svg class="left-deco">
          <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-left.svg#main'" />
        </svg>
        <svg class="right-deco">
          <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-right.svg#main'" />
        </svg>
      </div>
      <v-card class="form-box div-fadeUp">
        <v-btn :to="{ name: 'welcome' }" icon text class="backtohome">
          <v-icon v-text="'mdi-home-outline'" color="rgba(255, 255, 255, 0.75)" />
          <v-icon v-text="'mdi-arrow-left'" color="rgba(255, 255, 255, 0.90)" />
        </v-btn>
        <div class="auth-frame">
          <v-row>
            <v-col md="5" cols="12">
              <hidden point="smDown">
                <div class="greeting">
                  <div class="logo">
                    <router-link :to="{ name: 'welcome' }">
                      <img :src="ASSETS_URL + 'logo.svg'" alt="B" />
                      <p class="use-text-subtitle2">
                        {{ brand.projectName }}
                      </p>
                    </router-link>
                  </div>
                  <h4 class="use-text-title2 pb-2">
                    <slot name="title">
                      {{ title }}
                    </slot>
                  </h4>
                  <h6 class="use-text-paragraph">
                    <slot name="subtitle">
                      {{ subtitle }}
                    </slot>
                  </h6>
                </div>
              </hidden>
            </v-col>
            <v-col md="7" cols="12">
              <div class="form-wrap">
                <slot />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<style lang="scss">
@import "./form-style.scss";
</style>

<script>
import Hidden from "../../components/auto/Hidden.vue";
import brand from "@/landing/static/text/brand";
import routerLink from "@/landing/static/text/link";
export default {
  components: {
    Hidden,
  },
  data() {
    return {
      brand: brand,
      routerLink: routerLink,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>